import { Header, Label } from '@mairistem/composants';
import React from 'react';
import DECISION from '../../../constants/common/decision';
import './TreeViewLibelleRow.css';

interface TreeViewLibelleRowProps {
	code: string;
	decision: number;
	libelle: string;
	isChild: boolean;
}

const TreeViewLibelleRow = ({
	code,
	decision,
	libelle,
	isChild,
}: TreeViewLibelleRowProps) => (
	<div className={`treeViewLibelleRow ${isChild ? 'child' : ''}`}>
		<div>
			<Label
				circular
				content={code ? (decision === DECISION.AP ? 'AP' : 'AE') : 'EV'}
				color={code ? (decision === DECISION.AP ? 'red' : 'blue') : 'green'}
			/>
		</div>
		<Header size="tiny">
			<Header.Content>
				{libelle}
				<Header.Subheader>{code ?? ''}</Header.Subheader>
			</Header.Content>
		</Header>
	</div>
);

export default TreeViewLibelleRow;
